import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader } from "./shared";

export default function InquiriesTab() {
    const [items, setItems] = useState([]);
    const refresh = () => api.get("/inquiries").then((r) => setItems(r.data));
    useEffect(() => { refresh(); }, []);
    const updateStatus = async (id, status) => {
        try { await api.patch(`/inquiries/${id}/status`, { status }); refresh(); toast.success("Updated"); }
        catch { toast.error("Failed"); }
    };
    return (
        <div data-testid="admin-inquiries">
            <PageHeader eyebrow="Admin · Inquiries" title="Messages from guests." />
            <div className="space-y-4">
                {items.length === 0 && <div className="text-muted2">No inquiries yet.</div>}
                {items.map((i) => (
                    <div key={i.id} className="border border-espresso/15 p-6" data-testid={`inquiry-${i.id}`}>
                        <div className="flex justify-between items-start mb-3">
                            <div>
                                <div className="font-serif text-xl">{i.name}</div>
                                <div className="text-xs text-muted2">{i.email} · {i.phone || "—"}</div>
                            </div>
                            <span className={`px-2 py-1 text-[10px] uppercase tracking-widest2 border ${i.status === "new" ? "border-terracotta/40 text-terracotta" : "border-espresso/30 text-espresso"}`}>{i.status}</span>
                        </div>
                        {i.subject && <div className="eyebrow mb-2">{i.subject}</div>}
                        <p className="text-sm text-ink/80 leading-relaxed mb-4">{i.message}</p>
                        <div className="flex gap-3">
                            <button onClick={() => updateStatus(i.id, "responded")} className="text-xs uppercase tracking-widest2 text-forest hover:text-terracotta">Mark responded</button>
                            <button onClick={() => updateStatus(i.id, "archived")} className="text-xs uppercase tracking-widest2 text-espresso hover:text-terracotta">Archive</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
